$shm_hitalama_guide_repository $mol_page
	title \Репозиторий руководства
	catalog $shm_hitalama_guide_catalog
	opened? true
	tools /
		<= Close $mol_button_minor
			hint \Закрыть репозиторий руководства
			click? <=> close? null
			sub / <= Close_icon $mol_icon_close
	body /
		<= Repository $mol_labeler
			title \GitHub-репозиторий
			Content <= Repository_input $mol_string
				enabled <= editable false
				value? <=> repository? \hitalama/hitalama-docs
		<= Notice $mol_text
			text \Коммит сохраняет все страницы, ссылки и начальные страницы разделов. Новый репозиторий создаётся закрытым. Руководство в гипербазе остаётся публичным. GitHub-токен берётся из приватных настроек профиля.
		<= Status $mol_status
			status <= status \
			attr *
				^
				data-sync-state <= sync_state \
		<= Actions $mol_view
			sub /
				<= Refresh $mol_button_minor
					title \Обновить проверку
					click? <=> refresh? null
				<= Commit $mol_button_major
					title \Сделать коммит
					enabled <= commit_enabled false
					click? <=> commit? null
